import api from "@/api/contestApi";
import { toFormData, multipartHeaders } from "@utils/queries";

export default {
  async getVideosList() {
    const { data } = await api.get(`/video-site/index`);
    return data;
  },

  async getRecordsList() {
    const { data } = await api.get(`/video/index`);
    return data;
  },

  async getVideo(id) {
    const { data } = await api.get(`/video-site/view?id=${id}`);
    return data;
  },

  async getRecord(id) {
    const { data } = await api.get(`/video/view?id=${id}`);
    return data;
  },

  async getMyRecord() {
    const { data } = await api.get(`/video/my`);
    return data;
  },

  async uploadRecord(file, video_id) {
    const formData = toFormData({ file, video_id });
    const { data } = await api.post(
      "/video/upload",
      formData,
      multipartHeaders
    );
    return data;
  }
};
